module.exports = __webpack_public_path__ + "media/images/logo/arkea-5e121b7ac658ee6ec3ea9461dd7b9733.png";